
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/ai-writer",
      function () {
        return require("private-next-pages/dashboard/ai-writer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/ai-writer"])
      });
    }
  